<script>
import options from "./RelatedProduct.options";
export default options;
</script>

<template>
    <article class="nti-related-product">
        <h5 class="nti-related-product__container-title" v-if="data">{{ labels.relatedCollectionBannerSectionTitle }}</h5>
        <template v-for="card in data" :key="card.id">
            <a :href="card.link">
                <article class="nti-related-product__card" :style="card.imageUrl ? { backgroundImage: `linear-gradient(0deg, rgba(38, 48, 56, 0.8), rgba(38, 48, 56, 0.8)), url(${card.imageUrl})` } : null">
                    <div class="nti-related-product__card__left-container">
                        <h3 class="nti-related-product__card__title">{{ card.title }}</h3>
                        <p class="nti-related-product__card__text">{{ card.description }}</p>
                    </div>
                    <div class="nti-related-product__card__right-container">
                        <h3 v-if="card.priceText" class="nti-related-product__card__price">
                            <span class="nti-related-product__card__small-font">
                                {{ verifyLabel('fromPriceLabel') }}
                            </span>
                            {{ card.priceText }}
                        </h3>
                        <button class="nti-button nti-button--related-product">{{ card.buttonText }}</button>
                    </div>
                </article>
            </a>
        </template>
    </article>
</template>